export default "__VITE_ASSET__DDDpTCwY__"